import React, { Component } from 'react';
import styled, { css } from 'styled-components';
import { connect } from 'react-redux';

class ErrorDialog extends Component {
    constructor(props) {
        super(props);

        this.state = {
            error: this.props.error ? this.props.error : {},
        }
    }
    static getDerivedStateFromProps(nextProps, prevState) {
        let res = {};
        if (prevState.error !== nextProps.error) {
            res.error = prevState.error !== nextProps.error ? nextProps.error : prevState.error;
        }
        return res;
    }
    onClick = () => {
        this.props.dispatch({
            type: "ErrorClear",
        });
        this.props.dispatch({
            type: "LoadEnd"
        });
    }
    render() {
        let error = this.state.error ? this.state.error : {display: false, source: "", code: 0, info: {message:""}};
        let info = "";
        if(error.info) {
             info = error.info.message === undefined ? error.info : error.info.message;
        }
        return (
            <ErrorBg Display={error.display}>
                <ErrorDlg>
                    <ErrorTitle>通信エラー</ErrorTitle>
                    <ErrorContents Selectable={error.display}>
                        通信エラーが発生しました<br/>
                        <ErrorInfo>
                            発生箇所: {error.source}<br/>
                            エラーコード: {error.code}<br/>
                            内容: {info}
                        </ErrorInfo>
                        OKボタンを押すとアプリに戻ります<br/>
                        頻繁に発生する場合はお手数ですが<br/>
                        こちらの画面の内容でお問い合わせください
                        <ErrorInfo>
                            お問い合わせ先: info.prime@englishcompany.jp
                        </ErrorInfo>
                    </ErrorContents>
                    <ErrorControl onClick={this.onClick}>
                        OK
                    </ErrorControl>
                </ErrorDlg>
            </ErrorBg>
        )
    }
}
const mapStateToProps = store => {
    return {
        error: store.error.error,
    }
};

const connectedErrorDialog = connect(mapStateToProps)(ErrorDialog);
export { connectedErrorDialog as ErrorDialog };

const ErrorBg = styled.div `
    position: absolute;
    width: 100%;
    height: 100%;
    top: 0;
    left: 0;
    display: ${props => props.Display ? "block" : "none"};
    background-color: rgba(0, 0, 0, 0.2);
    z-index: 100;
`;
const ErrorDlg = styled.div`
    position: absolute;
    min-width: 300px;
    min-height: 400px;
    top: 50%;
    left: 50%;
    transform: translate(-50%, -50%);
    background-color: #fff;
    border-radius: 10px;
    display: flex;
    flex-direction: column;
    justify-content: flex-start;
    align-items: center;
`;
const ErrorTitle = styled.h3`
    margin: 10px 0;
`;
const ErrorContents = styled.article`
    margin: 10px 10px;
    text-align: left;
    ${props => props.Selectable ? css`
    -webkit-touch-callout: text; /* iOS Safari */
    -webkit-user-select: text; /* Safari */
    -khtml-user-select: text; /* Konqueror HTML */
    -moz-user-select: text; /* Firefox */
    -ms-user-select: text; /* Internet Explorer/Edge */
    user-select: text; /* Non-prefixed version, currently supported by Chrome and Opera */
    ` : ``};
`;
const ErrorInfo = styled.div`
    margin: 10px 0;
`;
const ErrorControl = styled.div`
    position: absolute;
    width: 100%;
    bottom: 0;
    padding: 10px 0;
    border-top: 1px solid #ddd;
    text-align: center;
`;